// Firm identity header for client-facing pages. Hollow mark if the firm has
// not uploaded a logo; otherwise renders the logo at a fixed height.
import { BridgeMark } from '../icons/Svg';

export default function FirmHeader({ branding, subtle = false }) {
  const { displayName, tagline, logoUrl } = branding;
  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <div className="flex items-center gap-3">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={displayName}
            className="h-10 w-auto max-w-[180px] object-contain"
          />
        ) : (
          <BridgeMark size={36} color={branding.primary} accent={branding.accent} />
        )}
        <span className="font-sans text-xl font-semibold tracking-tight text-[hsl(var(--fg))]">
          {displayName}
        </span>
      </div>
      {!subtle && tagline && (
        <p className="max-w-md text-sm text-[hsl(var(--fg-muted))]">{tagline}</p>
      )}
    </div>
  );
}
